
import { OLMSApiService } from '@/shared/apis'
import { RootState } from '@/shared/store'
import { createAsyncThunk, EntityId } from '@reduxjs/toolkit'

export type LockOrderPayload = {
  shiftId: EntityId
  orderIds: EntityId[]
}

export const lockOrder = createAsyncThunk<void, LockOrderPayload, { state: RootState }>(
  'shiftTable/lockOrder',
  async ({ shiftId, orderIds }, { getState }) => {
    const state = getState()
    const currentScreen = state.userInterface.currentScreen
    const endpoint = currentScreen === 'planning' ? '/planning/lockOrders' : '/runsheet/lockOrders'

    await OLMSApiService.post<null>(endpoint, {
      orderIds,
      shiftId,
    })
  },
)
